import { render, staticRenderFns } from "./RecordLink.vue?vue&type=template&id=0eb60d83&"
import script from "./RecordLink.vue?vue&type=script&lang=js&"
export * from "./RecordLink.vue?vue&type=script&lang=js&"
import style0 from "./RecordLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports